/* ============================================================================
   OCD DECK CUSTOMIZER — production (Dawn)  [FINAL2]
   - Drawer refresh populates content THEN opens (no trapFocus crash)
   - Only adds items not already in the cart (fixes 1-per-cart deck, no dupes)
   - Free grip / poly bag attached to deck; paid grip = separate line
   - Grip tape width filtering: free/generic grip always shows (cut to fit in
     store); paid grip tagged "10\" Plus Griptape" always shows; paid grip
     without that tag (untagged ~9" MOB tape) only shows for decks 9.0" and under
   ============================================================================ */
(function () {
  'use strict';

  var CFG = window.OCD_BUILDER || {};
  var MOUNT = document.getElementById('ocd-builder');
  if (!MOUNT) return;

  var SLOTS = [
    { key: 'grip',     label: 'grip or poly bag', required: true,  filtered: false },
    { key: 'trucks',   label: 'trucks',           required: false, filtered: true  },
    { key: 'wheels',   label: 'wheels',           required: false, filtered: true  },
    { key: 'bearings', label: 'bearings',         required: false, filtered: false },
    { key: 'bolts',    label: 'bolts',            required: false, filtered: false }
  ];
  var GRIP_PINNED = [
    'ocd-skateboard-deck-poly-bag-free',
    'modus-perforated-9-black-grip-free',
    'mob-griptape-mob-black-grip-9-x-33',
    'mob-griptape-mob-black-grip-10-x-33',
    'mob-griptape-mob-black-grip-11',
    'mob-clear-10-0-griptape'
  ];
  var GRIP_ALWAYS_SHOW = [
    'mob-clear-10-0-griptape'
  ];

  var TRUCK_COLS = [7.0,7.5,7.75,8.0,8.125,8.25,8.375,8.5,8.625,8.75,8.875,9.0,9.125,9.25,9.5,9.75,10.0];
  var TRUCK_FIT = {
    'independent': [['109'],['129'],['129','139'],['139'],['139','144'],['144'],['144','149'],['149'],['149','159'],['159'],['159'],['169'],['169'],['169'],['169'],['215'],['215']],
    'thunder':     [['143'],['145'],['145','147'],['147'],['147','148'],['148'],['148','149'],['149'],['149','151'],['151'],['151'],['151','161'],['161'],['161'],['161'],['181'],['181']],
    'ace':         [[],['22'],['22','33'],['33'],['33','44'],['33','44'],['44','55'],['44','55'],['44','55'],['55'],['55','66'],['55','66'],['55','66'],['55','66'],['66'],['66'],['80']],
    'venture':     [[],['5.0'],['5.0','5.2'],['5.2'],['5.2','5.6'],['5.6'],['5.6','5.8'],['5.8'],['5.8','6.1'],['6.1'],['6.1'],['6.1'],[],[],[],[],[]],
    'slappy':      [[],['7.5'],['7.5','8.0'],['8.0'],['8.0','8.25'],['8.25'],['8.25','8.5'],['8.5'],['8.5','8.75'],['8.75'],['8.75','9.0'],['9.0'],['9.0','9.25'],['9.25'],['9.5'],['9.5','10.0'],['10.0']],
    'krux':        [[],['7.6'],['7.6','8.0'],['8.0'],['8.0','8.25'],['8.25'],['8.25','8.5'],['8.5'],['8.5'],['8.5','9.0'],['9.0'],['9.0'],['9.0'],['9.0'],[],[],[]],
    'lurpiv':      [[],[],['140'],['140'],['140','145'],['145'],['145','150'],['150'],['150'],['150','160'],['160'],['160'],['160'],['160'],[],[],[]],
    'tensor':      [['4.25'],['4.75','5.0'],['5.0','5.25'],['5.25'],['5.25','5.5'],['5.5'],['5.5','5.75'],['5.75'],['5.75'],['5.75'],[],[],[],[],[],[],[]],
    'mini logo':   [['7.13'],['7.63'],['7.63','8.0'],['8.0'],['8.0'],['8.0','8.38'],['8.38'],['8.38'],['8.38','8.75'],['8.75'],['8.75'],['8.75'],[],[],[],[],[]],
    'bullet':      [['110'],['120','130'],['130','140'],['140'],['140','145'],['145'],['145','150'],['150'],['150'],['150'],[],[],[],[],[],['185'],['185']]
  };

  var sel = { grip:null, trucks:null, wheels:null, bearings:null, bolts:null };
  var applyGrip = false, assemble = false, cache = {}, pickerFilter = { brand:null, size:null }, currentSlot = null, guideOpen = false;

  function money(v){ var n = typeof v==='number'?v:parseFloat(v); if(isNaN(n))return ''; return (CFG.moneySymbol||'$')+n.toFixed(2); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function cap(s){ return s.charAt(0).toUpperCase()+s.slice(1); }
  function isPolyBag(p){ return /poly\s*bag/i.test(p.name); }
  function slotDef(key){ for(var i=0;i<SLOTS.length;i++){ if(SLOTS[i].key===key) return SLOTS[i]; } return null; }
  function labelFor(key){ var s=slotDef(key); return s?s.label:key; }

  function deckWidthNum(){
    var t=(CFG.deckTitle||'');
    var m=t.match(/(\d{1,2}(?:\.\d+)?)"?\s*(?:Skateboard\s+)?Deck\s*$/i);
    if(!m) m=t.match(/(\d{1,2}(?:\.\d+)?)/);
    return m?parseFloat(m[1]):null;
  }
  function gripHandleForDeck(){ var w=deckWidthNum(); if(w!=null && w>=10.0) return CFG.handles.gripWide; return CFG.handles.grip; }
  function handleForSlot(key){ return key==='grip'?gripHandleForDeck():CFG.handles[key]; }

  function truckColIndex(w){
    if(w==null) return -1;
    if(w<=7.0) return 0;
    if(w>=10.0) return TRUCK_COLS.length-1;
    var best=0,bd=1e9;
    for(var i=0;i<TRUCK_COLS.length;i++){ var d=Math.abs(TRUCK_COLS[i]-w); if(d<bd){ bd=d; best=i; } }
    return best;
  }
  function truckFits(p){
    var w=deckWidthNum(); if(w==null) return true;
    var ci=truckColIndex(w); if(ci<0) return true;
    var row=TRUCK_FIT[(p.brand||'').toLowerCase()];
    if(!row) return false;
    if(!p.size) return false;
    return (row[ci]||[]).indexOf(String(p.size))!==-1;
  }
  function gripFits(p){
    if(p.free) return true;
    if(GRIP_ALWAYS_SHOW.indexOf(p.handle)!==-1) return true;
    var w=deckWidthNum(); if(w==null) return true;
    if(p.gripTenPlus) return w>9.0;
    return w<=9.0;
  }

  function loadCollection(handle){
    if(cache[handle]) return Promise.resolve(cache[handle]);
    var all=[];
    function page(p){
      var url='/collections/'+handle+'/products.json?limit=250&page='+p;
      return fetch(url,{credentials:'same-origin'})
        .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status+' for '+handle); return r.json(); })
        .then(function(data){
          var items=(data&&data.products)||[];
          all=all.concat(items);
          if(items.length===250 && p<6) return page(p+1);
          cache[handle]=all.map(normalise);
          return cache[handle];
        });
    }
    return page(1);
  }
  function normalise(p){
    var v=(p.variants&&p.variants[0])||{}; var img=(p.images&&p.images[0]&&p.images[0].src)||''; var tags=p.tags||[];
    var price=parseFloat(v.price!=null?v.price:0);
    return { id:String(p.id), handle:p.handle, brand:p.vendor||'', name:p.title||'', price:price,
      compareAt:v.compare_at_price?parseFloat(v.compare_at_price):null, available:!!v.available, variantId:v.id, image:img,
      size:readSize(tags), free:price===0, gripTenPlus:hasGripTenPlusTag(tags) };
  }
  function readSize(tags){ for(var i=0;i<tags.length;i++){ var m=String(tags[i]).toLowerCase().match(/(?:truck_size|wheel_size|size):\s*([\d.]+)/); if(m) return m[1]; } return null; }
  function hasGripTenPlusTag(tags){ for(var i=0;i<tags.length;i++){ if(String(tags[i]).toLowerCase().indexOf('plus griptape')!==-1) return true; } return false; }

  function renderPanel(){
    var added=SLOTS.filter(function(s){return sel[s.key];}).length;
    var html='<div class="ocdb-panel"><div class="ocdb-head"><h2>Add Board Components</h2><span class="ocdb-count">'+added+' of 5 added</span></div><div class="ocdb-slots">';
    SLOTS.forEach(function(s){
      var chosen=sel[s.key], priceHtml, labelHtml;
      if(chosen){ priceHtml=chosen.free?'<span class="ocdb-free">+ Free</span>':'+ '+money(chosen.price); labelHtml='<span class="ocdb-chosen-label">'+esc(chosen.name)+'</span>'; }
      else{ priceHtml='+ '+money(0)+(s.required?' <span class="ocdb-req">(Required)</span>':''); labelHtml='Select '+s.label; }
      html+='<div class="ocdb-slot'+(chosen?' is-chosen':'')+'" data-slot="'+s.key+'" role="button" tabindex="0"><div class="ocdb-chip">'+(chosen?chipImg(chosen):'+')+'</div><div class="ocdb-slot-main"><div class="ocdb-slot-price">'+priceHtml+'</div><div class="ocdb-slot-label">'+labelHtml+'</div>'+(chosen?'<button type="button" class="ocdb-remove" data-remove="'+s.key+'">&times; Remove</button>':'')+'</div><button type="button" class="ocdb-change" data-change="'+s.key+'">Change</button></div>';
      if(s.key==='grip'&&chosen&&!isPolyBag(chosen)){
        html+='<div class="ocdb-applygrip"><span class="ocdb-ag-lead">Grip it for you? It\'s free.</span><div class="ocdb-seg"><button type="button" data-apply="0" class="'+(applyGrip?'':'on')+'">Don\'t grip</button><button type="button" data-apply="1" class="'+(applyGrip?'on':'')+'">Please grip</button></div></div>';
      }
    });
    html+='</div></div>';
    var total=(CFG.deckPrice||0); SLOTS.forEach(function(s){ if(sel[s.key]) total+=sel[s.key].price; });
    var allChosen=SLOTS.every(function(s){ return sel[s.key]; });
    var canAssemble=allChosen&&!!sel.grip&&!isPolyBag(sel.grip)&&applyGrip;
    if(!canAssemble) assemble=false;
    if(canAssemble){ html+='<div class="ocdb-assembly"><div class="ocdb-asm-main"><div class="ocdb-asm-title">Have us assemble it?</div><div class="ocdb-asm-sub">Your board\'s complete. We\'ll build it ready to ride. Free.</div></div><button type="button" class="ocdb-asm-toggle'+(assemble?' on':'')+'" data-assemble>'+(assemble?'Yes, assemble':'Add assembly')+'</button></div>'; }
    else if(allChosen){ html+='<div class="ocdb-assembly is-off"><div class="ocdb-asm-main"><div class="ocdb-asm-title">Want it assembled?</div><div class="ocdb-asm-sub">'+(isPolyBag(sel.grip)?'Choose a grip instead of the poly bag, then select "Please grip" and we\'ll build it for free.':'Select "Please grip" above and we\'ll build it ready to ride. Free.')+'</div></div></div>'; }
    html+='<div class="ocdb-total"><span>Your setup</span><strong>'+money(total)+'</strong></div><button type="button" class="ocdb-addcart" id="ocdb-addcart">Add to cart</button><div class="ocdb-cartmsg" id="ocdb-cartmsg"></div>';
    MOUNT.innerHTML=html;
  }
  function chipImg(p){ return p.image?'<img src="'+p.image+'" alt="">':'<span>'+esc((p.brand||'?').charAt(0))+'</span>'; }

  function openPicker(key){
    currentSlot=key; pickerFilter={brand:null,size:null};
    showModal(key,'<div class="ocdb-loading">Loading '+esc(labelFor(key))+'&hellip;</div>');
    loadCollection(handleForSlot(key)).then(function(){ renderPicker(key); }).catch(function(err){ showModal(key,'<div class="ocdb-error">Couldn\'t load these products.<br><small>'+esc(err.message)+'</small></div>'); });
  }
  function orderedProducts(key){
    var handle=handleForSlot(key);
    var products=(cache[handle]||[]).filter(function(p){ return p.available; });
    if(key==='trucks') products=products.filter(truckFits);
    if(key==='grip') products=products.filter(gripFits);
    if(key==='grip'){ products=products.slice().sort(function(a,b){ var ia=GRIP_PINNED.indexOf(a.handle); if(ia===-1)ia=999; var ib=GRIP_PINNED.indexOf(b.handle); if(ib===-1)ib=999; return ia-ib; }); }
    return products;
  }
  var GUIDES = {
    wheels: {
      title: 'Which wheel size do I need?',
      body:
        '<p class="ocdb-guide-intro">It comes down to how the board will mostly be used:</p>'+
        '<div class="ocdb-guide-opt"><div class="ocdb-guide-opt-head"><span class="ocdb-guide-opt-name">Street &amp; tricks</span><span class="ocdb-guide-spec">50-53mm &middot; hard</span></div><p>Ledges, flat ground, ollies and flips. Smaller, harder wheels are lighter and more stable for tricks.</p></div>'+
        '<div class="ocdb-guide-opt is-pick"><div class="ocdb-guide-opt-head"><span class="ocdb-guide-opt-name">Skatepark &amp; ramps</span><span class="ocdb-guide-spec">54-56mm &middot; hard</span><span class="ocdb-guide-tag">Most popular</span></div><p>Parks, bowls, transition, or just an all-round board. The safe pick if you\'re unsure.</p></div>'+
        '<div class="ocdb-guide-opt"><div class="ocdb-guide-opt-head"><span class="ocdb-guide-opt-name">Cruising &amp; getting around</span><span class="ocdb-guide-spec">56mm+ &middot; soft</span></div><p>Rolling to the shops, footpaths, rougher ground. Bigger, softer wheels roll smoother and quieter over cracks.</p></div>'+
        '<p class="ocdb-guide-note">The "A" number is hardness: high (99A) is hard for parks and tricks, low (78A) is soft for comfy cruising.</p>'
    },
    bolts: {
      title: 'Which bolts do I need?',
      body:
        '<p class="ocdb-guide-intro">Bolts attach the trucks to the deck. There are just two things to pick:</p>'+
        '<div class="ocdb-guide-opt"><div class="ocdb-guide-opt-head"><span class="ocdb-guide-opt-name">Length</span></div><p>Standard bolts (7/8" or 1") fit a normal setup, which is almost everyone. Longer bolts are only needed if a board has riser pads fitted between the deck and trucks.</p></div>'+
        '<div class="ocdb-guide-opt"><div class="ocdb-guide-opt-head"><span class="ocdb-guide-opt-name">Allen or Phillips</span></div><p>Just the tool you\'ll use to fit them: Allen = hex key, Phillips = cross-head screwdriver. Pick whichever you have, since many skate tools include both.</p></div>'+
        '<p class="ocdb-guide-note">For a standard board, 7/8"-1" bolts are the safe choice.</p>'
    }
  };
  function guideHtml(key){
    var g=GUIDES[key]; if(!g) return '';
    return '<div class="ocdb-guide'+(guideOpen?' is-open':'')+'"><button type="button" class="ocdb-guide-head" data-ocdb-guide><span class="ocdb-guide-q">?</span><span class="ocdb-guide-title">'+g.title+'</span><span class="ocdb-guide-chev" aria-hidden="true">&#9662;</span></button><div class="ocdb-guide-body">'+g.body+'</div></div>';
  }

  function renderPicker(key){
    var products=orderedProducts(key);
    var showFilters=slotDef(key).filtered;
    var list=products.filter(function(p){ if(pickerFilter.brand&&p.brand!==pickerFilter.brand)return false; if(pickerFilter.size&&p.size!==pickerFilter.size)return false; return true; });
    var html=guideHtml(key);
    if(key==='trucks'){ var w=deckWidthNum(); if(w!=null) html+='<div class="ocdb-fitnote">Showing trucks that fit your '+esc(String(w))+'&Prime; deck.</div>'; }
    if(showFilters){
      var brandPool=products.filter(function(p){ return !pickerFilter.size||p.size===pickerFilter.size; });
      var sizePool=products.filter(function(p){ return !pickerFilter.brand||p.brand===pickerFilter.brand; });
      var brands=uniqSorted(brandPool.map(function(p){ return p.brand; }),false);
      var sizes=uniqSorted(sizePool.map(function(p){ return p.size; }).filter(Boolean),true);
      var sizeGated=(key==='trucks'); var showSizes=!sizeGated||!!pickerFilter.brand;
      var sizeInner=showSizes?sizes.map(function(s){ return pill('fsize',s,pickerFilter.size===s); }).join(''):'<span class="ocdb-fhint">Pick a brand to see sizes</span>';
      html+='<div class="ocdb-filterbar"><div class="ocdb-fgroup"><span class="ocdb-flabel">Brand</span><div class="ocdb-fpills">'+brands.map(function(b){ return pill('fbrand',b,pickerFilter.brand===b); }).join('')+'</div></div><div class="ocdb-fgroup"><span class="ocdb-flabel">Size</span><div class="ocdb-fpills">'+sizeInner+'</div></div>'+((pickerFilter.brand||pickerFilter.size)?'<button type="button" class="ocdb-fclear" data-fclear>Clear filters</button>':'')+'<div class="ocdb-fcount">'+list.length+' of '+products.length+' shown</div></div>';
    }
    html+='<div class="ocdb-pgrid">';
    if(!list.length){ html+='<div class="ocdb-fempty">No matching products.'+(showFilters?'<br>Try clearing a filter.':'')+'</div>'; }
    else{
      list.forEach(function(p){
        var active=sel[key]&&sel[key].id===p.id;
        var price=p.free?'<span class="ocdb-free">+ Free</span>':(p.compareAt&&p.compareAt>p.price?'<span class="ocdb-was">'+money(p.compareAt)+'</span><span class="ocdb-now">'+money(p.price)+'</span>':'+ '+money(p.price));
        html+='<div class="ocdb-card'+(active?' is-active':'')+'"><div class="ocdb-thumb">'+(p.image?'<img src="'+p.image+'" alt="">':'')+'</div><div class="ocdb-cbrand">'+esc(p.brand)+'</div><div class="ocdb-cname">'+esc(p.name)+(p.size&&showFilters?' <span class="ocdb-csize">&middot; '+esc(p.size)+'</span>':'')+'</div><div class="ocdb-cprice">'+price+'</div><button type="button" class="ocdb-select" data-pick="'+esc(p.id)+'" data-slot="'+esc(key)+'">'+(active?'Selected':'Select')+'</button></div>';
      });
    }
    html+='</div>';
    setModalBody(html,true);
  }
  function showModal(key,bodyHtml){
    var ex=document.getElementById('ocdb-overlay'); if(ex)ex.remove();
    var o=document.createElement('div'); o.id='ocdb-overlay'; o.className='ocdb-overlay';
    o.innerHTML='<div class="ocdb-modal" role="dialog" aria-modal="true"><div class="ocdb-modal-head"><span class="ocdb-modal-sub">'+esc(cap(key))+'</span><h3>Products</h3><button type="button" class="ocdb-modal-done">Done</button><button type="button" class="ocdb-modal-close" aria-label="Close">&times; Close</button></div><div class="ocdb-modal-note">'+(slotDef(key).required?'Required. Choose any grip. The free grip or free poly bag cost nothing.':'Optional. Skip it if you\'re only after the deck.')+'</div><div class="ocdb-modal-body" id="ocdb-modal-body">'+bodyHtml+'</div></div>';
    document.body.appendChild(o);
  }
  function setModalBody(html,keepScroll){ var b=document.getElementById('ocdb-modal-body'); if(!b)return; var pos=keepScroll?b.scrollTop:0; b.innerHTML=html; b.scrollTop=pos; }
  function closeModal(){ var o=document.getElementById('ocdb-overlay'); if(o)o.remove(); }
  function uniqSorted(arr,numeric){ var out=[]; arr.forEach(function(x){ if(x!=null&&out.indexOf(x)===-1)out.push(x); }); out.sort(numeric?function(a,b){return parseFloat(a)-parseFloat(b);}:undefined); return out; }
  function pill(kind,val,on){ return '<button type="button" class="ocdb-fpill'+(on?' on':'')+'" data-'+kind+' data-val="'+esc(val)+'">'+esc(val)+'</button>'; }
  function pickProduct(id,slotFromBtn){
    var slotKey=slotFromBtn||currentSlot; id=String(id); var chosen=null; var handle=handleForSlot(slotKey); var pool=cache[handle]||[];
    for(var i=0;i<pool.length;i++){ if(pool[i].id===id){ chosen=pool[i]; break; } }
    if(!chosen){ Object.keys(cache).forEach(function(h){ (cache[h]||[]).forEach(function(p){ if(p.id===id)chosen=p; }); }); }
    if(!chosen){ console.log('OCD builder: could not find product id',id,'for slot',slotKey); return; }
    sel[slotKey]=chosen; if(slotKey==='grip'&&isPolyBag(chosen))applyGrip=false; renderPanel(); renderPicker(slotKey);
  }
  function toggleFilter(kind,val){
    pickerFilter[kind]=pickerFilter[kind]===val?null:val;
    if(pickerFilter.brand&&pickerFilter.size){ var ok=(orderedProducts(currentSlot)||[]).some(function(p){ return p.brand===pickerFilter.brand&&p.size===pickerFilter.size; }); if(!ok)pickerFilter[kind==='brand'?'size':'brand']=null; }
    renderPicker(currentSlot);
  }

  function addToCart(){
    var msg=document.getElementById('ocdb-cartmsg');
    var btn=document.getElementById('ocdb-addcart');
    if(!sel.grip){ if(msg){ msg.textContent='Choose a grip or poly bag first. The free options cost nothing.'; msg.className='ocdb-cartmsg is-error'; } openPicker('grip'); return; }
    if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
    if(msg){ msg.textContent=''; msg.className='ocdb-cartmsg'; }

    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      var inCart={};
      (cart.items||[]).forEach(function(li){ inCart[String(li.id)]=true; });

      var items=[]; var deckInCart=!!inCart[String(CFG.deckVariantId)]; var buildId='b'+Date.now().toString(36)+Math.random().toString(36).slice(2,6);
      if(!inCart[String(CFG.deckVariantId)]){
        var props={};
        if(sel.grip){
          if(sel.grip.free){
            var gname=sel.grip.name; if(!/free/i.test(gname)) gname+=' (free)';
            props['Grip']=gname;
            if(!isPolyBag(sel.grip)) props['Grip application']=applyGrip?'Apply for me':"Don't apply";
          } else {
            props['Grip']=sel.grip.name;
            props['Grip application']=applyGrip?'Apply for me':"Don't apply";
          }
        }
        if(assemble){ props['Assembly']='Build my complete board'; props['Build']=CFG.deckTitle; } props['_build']=buildId;
        items.push({ id:CFG.deckVariantId, quantity:1, properties:props });
      }
      ['trucks','wheels','bearings','bolts'].forEach(function(k){
        if(sel[k] && sel[k].variantId && (!deckInCart || !inCart[String(sel[k].variantId)])){
          var cprops={};
          if(assemble) cprops['For deck']=CFG.deckTitle;
          items.push({ id:sel[k].variantId, quantity:1, properties:cprops });
        }
      });
      if(sel.grip && !sel.grip.free && sel.grip.variantId && (!deckInCart || !inCart[String(sel.grip.variantId)])) items.push({ id:sel.grip.variantId, quantity:1, properties:{ '_build':buildId } });

      if(!items.length){
        if(btn){ btn.disabled=false; btn.textContent='Add to cart'; }
        if(msg){ msg.innerHTML='Everything selected is already in your cart. <a href="/cart">View cart</a>'; msg.className='ocdb-cartmsg is-ok'; }
        return;
      }
      return fetch('/cart/add.js',{
        method:'POST', headers:{ 'Content-Type':'application/json' },
        body:JSON.stringify({ items:items, sections:'cart-drawer,cart-icon-bubble', sections_url:window.location.pathname })
      })
      .then(function(r){ if(!r.ok) return r.json().then(function(e){ throw new Error(e.description||('HTTP '+r.status)); }); return r.json(); })
      .then(function(res){
        if(btn){ btn.disabled=false; btn.textContent='Add to cart'; }
        refreshDawnCart(res);
        if(msg){ msg.innerHTML='Added to cart. <a href="/cart">View cart</a>'; msg.className='ocdb-cartmsg is-ok'; }
      });
    })
    .catch(function(err){
      if(msg){ msg.textContent='Could not add to cart: '+err.message; msg.className='ocdb-cartmsg is-error'; }
      if(btn){ btn.disabled=false; btn.textContent='Add to cart'; }
      console.log('OCD builder add-to-cart error:',err);
    });
  }

  function refreshDawnCart(res){
    try {
      if(res && res.sections){
        updateSection(res.sections['cart-icon-bubble'], '#cart-icon-bubble', '.shopify-section');
        var drawerHtml = res.sections['cart-drawer'];
        if(drawerHtml){
          var tmp=document.createElement('div'); tmp.innerHTML=drawerHtml;
          var newInner = tmp.querySelector('.drawer__inner');
          var liveInner = document.querySelector('cart-drawer .drawer__inner');
          if(newInner && liveInner){ liveInner.innerHTML = newInner.innerHTML; }
          var dEl = document.querySelector('cart-drawer');
          if(dEl){ dEl.classList.remove('is-empty'); }
        }
      }
    } catch(e){ console.log('OCD builder cart populate note:', e); }
    try {
      var drawer=document.querySelector('cart-drawer');
      if(drawer && typeof drawer.open==='function'){ drawer.open(); }
    } catch(e){ console.log('OCD builder cart open note:', e); }
  }
  function updateSection(html,targetSel,innerSel){
    if(!html) return;
    var target=document.querySelector(targetSel);
    if(!target) return;
    var tmp=document.createElement('div'); tmp.innerHTML=html;
    var src=innerSel?tmp.querySelector(innerSel):tmp;
    if(src) target.innerHTML=src.innerHTML;
  }

  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('.ocdb-modal-close')||t.closest('.ocdb-modal-done')){ closeModal(); return; }
    var gtog=t.closest('[data-ocdb-guide]'); if(gtog){ e.preventDefault(); var gw=gtog.closest('.ocdb-guide'); if(gw){ gw.classList.toggle('is-open'); guideOpen=gw.classList.contains('is-open'); } return; }
    var overlay=document.getElementById('ocdb-overlay'); if(overlay&&t===overlay){ closeModal(); return; }
    var pick=t.closest('[data-pick]'); if(pick){ e.preventDefault(); pickProduct(pick.getAttribute('data-pick'),pick.getAttribute('data-slot')); return; }
    var fb=t.closest('[data-fbrand]'); if(fb){ toggleFilter('brand',fb.getAttribute('data-val')); return; }
    var fs=t.closest('[data-fsize]'); if(fs){ toggleFilter('size',fs.getAttribute('data-val')); return; }
    if(t.closest('[data-fclear]')){ pickerFilter={brand:null,size:null}; renderPicker(currentSlot); return; }
    if(t.closest('[data-assemble]')){ e.preventDefault(); assemble=!assemble; renderPanel(); return; }
    if(t.closest('#ocdb-addcart')){ e.preventDefault(); addToCart(); return; }
    var apply=t.closest('#ocd-builder [data-apply]'); if(apply){ e.preventDefault(); e.stopPropagation(); applyGrip=apply.getAttribute('data-apply')==='1'; renderPanel(); return; }
    var remove=t.closest('#ocd-builder [data-remove]'); if(remove){ e.preventDefault(); e.stopPropagation(); var rk=remove.getAttribute('data-remove'); sel[rk]=null; if(rk==='grip')applyGrip=false; renderPanel(); return; }
    var slot=t.closest('#ocd-builder .ocdb-slot'); if(slot){ e.preventDefault(); openPicker(slot.getAttribute('data-slot')); }
  });

  renderPanel();
})();